<template>
    <div class="col-lg-4 category-box">
        <router-link class="cat-link" :to="to">
            <div :style="{backgroundImage: 'url('+require('../assets/img/'+img+'.jpg')+')'}" class=" h-100 inner-category-box d-flex align-items-center justify-content-center">
            <h3 class="white">{{title}}</h3>
        </div>
        </router-link>
    </div>
</template>

<script>
   export default{
       props: ['img', 'title', 'to']
   }
</script>